import { render, staticRenderFns } from "./canvas_instruction.vue?vue&type=template&id=208f796c&scoped=true&"
import script from "./canvas_instruction.vue?vue&type=script&lang=js&"
export * from "./canvas_instruction.vue?vue&type=script&lang=js&"
import style0 from "./canvas_instruction.vue?vue&type=style&index=0&id=208f796c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f796c",
  null
  
)

export default component.exports